<div class="tab-container">
  <div class="input-group-title">Nicht installierbare Fühler</div>
  <div
    class="input-group-line divider"
    *ngFor="let sensor of model.nonInstallableSensors; index as i"
  >
    <div class="flex">
      <div class="input-group-line">
        <div class="input-group flex">
          <label [for]="'sensorType' + i">Typ*</label>
          <ng-select
            [name]="'sensorType' + i"
            [id]="'sensorType' + i"
            [(ngModel)]="sensor.type"
            required
            (ngModelChange)="sensor.sensorName = undefined"
          >
            <ng-option *ngFor="let option of sensorTypes" [value]="option"
              >{{ option }}
            </ng-option>
          </ng-select>
        </div>
        <div class="input-group flex">
          <label [for]="'sensorName' + i">Sensorname*</label>

          <ng-select
            [name]="'sensorName' + i"
            [id]="'sensorName' + i"
            required
            [(ngModel)]="sensor.sensorName"
          >
            <ng-option
              *ngFor="let option of sensorNameOptionsMap[sensor.type]"
              [value]="option"
              >{{ option }}
            </ng-option>
          </ng-select>
        </div>
      </div>
      <div class="input-group">
        <label [for]="'reason' + i">Grund*</label>
        <input
          type="text"
          required
          [name]="'reason' + i"
          [id]="'reason' + i"
          [(ngModel)]="sensor.reason"
        />
      </div>
    </div>
    <div class="icon-button">
      <i class="juc ju-delete" (click)="removeSensor(i)"></i>
    </div>
  </div>
  <div class="button-container">
    <button class="secondary" type="button" (click)="addNewSensor()">
      <i class="ju ju-add"></i>
      Hinzufügen
    </button>
  </div>

  <div class="input-group-title">Sonstige</div>
  <div class="input-group">
    <label for="generalComment">Allgemeiner Kommentar</label>
    <textarea
      cols="30"
      rows="10"
      placeholder="Hier können Sie optionale Kommentare eingeben."
      name="generalComment"
      id="generalComment"
      [(ngModel)]="model.generalComment"
    >
    </textarea>
  </div>
  <div class="input-group">
    <label for="installationComment">Kommentar an Inbetriebnehmer</label>
    <textarea
      cols="30"
      rows="10"
      placeholder="Hier können Sie optionale Kommentare eingeben."
      name="installationComment"
      id="installationComment"
      [(ngModel)]="model.installationComment"
    >
    </textarea>
  </div>
  <div class="buttons" *ngIf="installationData?.requestStatus === null">
    <button
      class="primary"
      [disabled]="!canSendMontage()"
      (click)="sendMontage()"
      [class]="{ disabled: !canSendMontage() }"
    >
      Montage senden
    </button>
  </div>
  <div
    *ngIf="installationData && installationData.requestStatus === 'ONGOING'"
    style="padding-top: 1rem"
  >
    Die Montage wurde bereits durchgeführt.
  </div>
  <div
    *ngIf="
      installationData &&
      installationData.requestStatus &&
      installationData.requestStatus !== 'ONGOING'
    "
    style="padding-top: 1rem"
  >
    Die Installation wurde bereits durchgeführt
  </div>
</div>
<div class="field">Pflichtfelder*</div>
<app-navigation-footer
  [isBackLinkDisabled]="false"
  [backLink]="'/gateway/general/measurement'"
  [isNextLinkDisabled]="!validationService.isGeneralSendingValid(model)"
  [nextLink]="'/gateway/building'"
  [isLast]="false"
></app-navigation-footer>
